module.exports = __webpack_public_path__ + "static/card-back-2-aee63437b55e1cf0d0a05107d5b1b443.png";